import { getDatePeriodFromNow } from './index';

export default function getUserLastLoginDate(user) {
  if (!user) return '';
  const { lastLoggedInAt, isActive } = user;

  if (lastLoggedInAt) return getDatePeriodFromNow(lastLoggedInAt);

  if (!lastLoggedInAt && isActive === false) return t('phrases.hasNotLoggedInYet', { ns: i18next.Namespace.COMMON });

  return '';
}
